// extracted by mini-css-extract-plugin
export default {"categoryName":"KpiSelectModalOnMap_categoryName__1MNpO","kpiItem":"KpiSelectModalOnMap_kpiItem__n-UsB"};